import { Controller } from "stimulus"

export default class extends Controller {
  connect() {
    this.choiceElements = Array.from(this.element.querySelectorAll(".js-choice"))

    this.choiceElements.forEach((element) => {
      if (element.choices) return

      element.choices = new Choices(element, {
        placeholderValue: element.dataset.choicesPlaceholder || "Sélectionner un élément",
        searchPlaceholderValue: "Chercher un élément",
        itemSelectText: '',
        removeItemButton: element.multiple,
        shouldSort: false
      })
    })
  }

  disconnect() {
    if (!this.choiceElements) return

    this.choiceElements.forEach((element) => {
      if (!element.choices) return

      element.choices.destroy()
      delete element.choices
    })
  }
}
